'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
require('./_index.scss.js');

var CLASSNAME = 'varta-layout-overview';
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function LayoutOverview(_ref) {
  var className = _ref.className,
      children = _ref.children,
      header = _ref.header,
      footer = _ref.footer,
      style = _ref.style;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(CLASSNAME, className)
  }, header, /*#__PURE__*/React__default.createElement("main", null, children), footer);
}
LayoutOverview.propTypes = {
  /** Child nodes */
  children: PropTypes.node,

  /** Additional class name */
  className: PropTypes.string,

  /** Footer component */
  footer: PropTypes.node,

  /** Header component */
  header: PropTypes.node,

  /** Additional style object */
  style: PropTypes.object
};

module.exports = LayoutOverview;
